import { Button, Empty, Spin, Typography, Collapse } from "antd";
import QuizCard from "./QuizCard";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import { CaretRightOutlined, PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import QuizQuestions from "Pages/MySchedule/MyScheduledBeta/quiz/QuizQuestions";

const { Panel } = Collapse;

const QuizList = () => {
  const {
    quizData,
    isLoading,
    setIsCreateMode,
    setEditableQuiz,
    isQuizEditable,
  } = useQuizContext();

  const [loadedQuizIds, setLoadedQuizIds] = useState<number[]>([]);

  const handleCollapseChange = (activeKeys: string | string[]) => {
    const keys = Array.isArray(activeKeys) ? activeKeys : [activeKeys];

    keys.forEach((quizId) => {
      if (!loadedQuizIds.includes(Number(quizId))) {
        setLoadedQuizIds((prev) => [...prev, Number(quizId)]);
      }
    });
  };
  const panelStyle: React.CSSProperties = {
    marginBottom: 24,
    border: "1px solid #f0f0f0",
    borderRadius: 8,
    overflow: "hidden",
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "calc(100vh - 300px)",
        gap: 12,
      }}
    >
      {isLoading && <Spin fullscreen />}

      {quizData?.length ? (
        <Collapse
          accordion={false}
          expandIconPosition={"end"}
          onChange={handleCollapseChange}
          size="small"
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          style={{ background: "#fff", border: "0px" }}
        >
          {quizData.map((quiz: any) => (
            <Panel
              header={<QuizCard quiz={quiz} />}
              key={quiz.id}
              style={panelStyle}
            >
              <QuizQuestions quiz={quiz}></QuizQuestions>
            </Panel>
          ))}
        </Collapse>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center w-100 h-100"
          style={{
            height: "400px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
          }}
        >
          <Empty
            image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
            styles={{ image: { height: 100 } }}
            description={<Typography.Text>No quiz available</Typography.Text>}
          >
            {isQuizEditable && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setIsCreateMode(true);
                  setEditableQuiz({});
                }}
              >
                Create New Quiz
              </Button>
            )}
          </Empty>
        </div>
      )}
    </div>
  );
};

export default QuizList;
